import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Meeting_Father_view from "./Meeting_Father_view";
import {Fragment, useEffect, useState} from "react";
import {empty_bk} from "../../clientconfigwebapp";
import $ from "jquery";
import Meeting_Lessons from "./Meeting_Lessons";
export default function Meeting_grupe_view(props) {

    const [expanded, setExpanded] = React.useState(false);
    const [status_open, setstatus_open] = React.useState(false);
    const [number_first_open, Set_number_first_open] =useState(1);

    const [id_grupe_open, setid_grupe_open] =useState('');


    const handleChange = (panel,props_id_grupe,grupe_item_get_id) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);


        Set_number_first_open((parseInt(number_first_open) + 1));

        if(number_first_open==1){
            if(props_id_grupe==grupe_item_get_id){       setstatus_open(true);   }else{      setstatus_open(false); }
        }


    };


    useEffect(() => {
        ///remove_class_item_a();

    }, [1]);



    return (

        <div className="box_full_item_grupe_meetting ">
            <input type="text" id="grupe_id"  value="636618587b3011f1cd45d3d8" style={{display:"none"}} />

            <Meeting_Lessons post_type={props.post_type} id_grupe={props.id_grupe} id_fhater={props.id_fhater} cource_id_get={props.cource_id_get}  data_lessons={props.data_lessons} page_view={props.page_view} data_info_details={props.data_info_details} lesson_id={props.lesson_id}  />


        </div>
    );
}

